import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-factura',
  templateUrl: './factura.component.html',
  styleUrls: ['./factura.component.scss']
})
export class FacturaComponent  {

  constructor(private loginService:LoginService) { }



  clickGuard(){
    this.loginService.clickGuard = true;
 }


}
